(function () {
  var STORAGE_KEY = 'modulus-wishlist';
  var CHANGE_EVENT = 'modulus-wishlist:change';

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    window.dispatchEvent(
      new CustomEvent(CHANGE_EVENT, { detail: { list: list.slice(), count: list.length } })
    );
  }

  var api = {
    getList: function () {
      return read();
    },
    has: function (handle) {
      return read().indexOf(handle) !== -1;
    },
    count: function () {
      return read().length;
    },
    add: function (handle) {
      if (!handle) return;
      var list = read();
      if (list.indexOf(handle) === -1) {
        list.push(handle);
        write(list);
      }
    },
    remove: function (handle) {
      var list = read();
      var idx = list.indexOf(handle);
      if (idx !== -1) {
        list.splice(idx, 1);
        write(list);
      }
    },
    toggle: function (handle) {
      if (!handle) return false;
      var list = read();
      var idx = list.indexOf(handle);
      if (idx === -1) {
        list.push(handle);
        write(list);
        return true;
      }
      list.splice(idx, 1);
      write(list);
      return false;
    },
    clear: function () {
      write([]);
    },
    subscribe: function (fn) {
      var handler = function (e) { fn(e.detail.list, e.detail.count); };
      window.addEventListener(CHANGE_EVENT, handler);
      return function () { window.removeEventListener(CHANGE_EVENT, handler); };
    },
    STORAGE_KEY: STORAGE_KEY,
    CHANGE_EVENT: CHANGE_EVENT
  };

  window.modulusWishlist = api;

  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      var list = read();
      window.dispatchEvent(
        new CustomEvent(CHANGE_EVENT, { detail: { list: list.slice(), count: list.length } })
      );
    }
  });
})();
